.count {
    font-size: 10px;
    line-height: 14px;
}

.count--not-active {
    color: #9b9ec1;
}
